var exports = {
  "Tq": "x61f99309--775f9c--bubble",
  "Zp": "x61f99309--775f9c--layout",
  "o5": "x61f99309--775f9c--content-wrapper",
  "Qs": "x61f99309--775f9c--content",
  "mI": "x61f99309--775f9c--meta",
};

module.exports = exports;
